import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getDeliveryPercentList,
  getGoldenCrossOver,
  getGoogleSheet,
  getSymbolList,
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router-dom";
import { AIPromptForStock1, diffDays, NSE_filter_marketcap } from "../utils/constants";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";

const GloldenCrossOverPage = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [getGoldenCrossData, setGoldenCrossData] = useState([]);
  const [getGoldenCrossDataList, setGoldenCrossDataList] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [startDate, setStartDate] = useState(new Date());
  const [deliveryDataList, setDeliveryDataList] = useState([]);
  const userToken = useSelector((state) => state.userToken.value);
  const [series, setSeries] = useState('EQ');
  const navigate = useNavigate();

  useEffect(() => {
      if (!userToken) {
        navigate(`/`);
        return;
      }

      const current_date = moment(startDate).format("DDMMYY");

      Promise.all([
        getGoldenCrossOver(userToken),
        getSymbolList(series, '', userToken),
        getGoogleSheet("", userToken),
        getDeliveryPercentList('', 'goldencross', '', '', 'EQ', '', userToken)
      ])
        .then(([goldenRes, symbolRes, sheetRes, delivery]) => {
          setGoldenCrossData(goldenRes?.data?.data || []);
          setSymbolData(symbolRes?.data?.data || []);
          setTodayData(sheetRes?.data?.data?.json_data || []);
          setDeliveryDataList(delivery.data.data);
          dispatch(setDeliveryDataReducer(delivery.data.data));
        })
        .catch((err) => {
          console.log("Error", err);
        });

  }, [startDate, userToken]);



  useEffect(() => {
    if (
      getGoldenCrossData.length > 0 &&
      symbolData.length > 0 &&
      todayData.length > 0
    ) {
      // let MarketCap = (series === "ETF" || series === "BOND")? 0:NSE_filter_marketcap;
      const filteredData = getGoldenCrossData
        .filter((obj) => {
          return symbolData.find(
            (item) =>
              item.symbol === obj.symbol &&
              item.active === "1" &&
              // && item.series === series
              item.MarketCap >= NSE_filter_marketcap
          );
        })
        .map((item) => {
          const match = symbolData.find(
            (s) => s.symbol === item.symbol && parseInt(s.MarketCap) > 1000
          );

          const deliverylist = Object.values(deliveryDataList);
          const deliveryData = deliverylist?.find((s) => s.symbol === item.symbol);
          const todayLTP = todayData.find((t) => t.TICKER === item.symbol);

 
          return {
            ...item,
            details: match,
            deliveryData: deliveryData,
            todayLTP: todayLTP,
          };
        });

       

      setGoldenCrossDataList(filteredData);
      setLoader(true);
    }
  }, [getGoldenCrossData, symbolData, todayData]);

  const removeStockHandler = (e, id) => {
    e.preventDefault();
    let params = {
      symbol_Id: id,
    };
  };

  const symbolCountMap = {};
  let totalPL = 0;

  
  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === false ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>Date</th>
                  <th style={{ width: "60px" }}>GC Date</th>
                  <th style={{ width: "30px" }}>Days</th>
                  <th style={{ width: "130px", textAlign: "left" }}>Symbol [{getGoldenCrossDataList?.length}]</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Score</th>
                  <th style={{ width: "45px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "40px", textAlign: "left" }}>Series</th>
                  <th style={{ width: "120px", textAlign: "left" }}>Sector</th>
                  <th style={{ width: "45px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "65px" }}>Cross Price</th>
                  <th style={{ width: "50px" }}>Chn%</th>
                  <th style={{ width: "50px" }}>LTP</th>
                  <th style={{ width: "50px" }}>LChn%</th>
                  <th style={{ width: "50px" }}>TChn%</th>
                  <th style={{ width: "50px" }}>SMA50</th>
                  <th style={{ width: "50px" }}>SMA200</th>
                  <th style={{ width: "50px" }}>52 Down</th>
                  <th style={{ width: "95px" }}>52 L/H</th>
                  <th style={{ width: "80px" }}>AT Vol</th>
                  <th style={{ width: "50px" }}>Del%</th>
                  <th style={{ width: "35px" }}>News</th>
                </tr>
              </thead>
              <tbody>
                {getGoldenCrossDataList?.map((item, index) => {
                  const symbolName = item.symbol;

                  

                  let prevVolume = (
                            ((parseInt(item.deliveryData?.stock_data[0].ttl_trd_qty) -
                              parseInt(item.deliveryData?.stock_data[1].ttl_trd_qty)) *
                              100) /
                            parseInt(item.deliveryData?.stock_data[1].ttl_trd_qty)
                          ).toFixed(2);


                  totalPL =
                    totalPL +
                    ((parseFloat(item.todayLTP?.LTP) -
                      parseFloat(item.cross_price)) *
                      100) /
                      parseFloat(item.cross_price);

                  return (
                    <tr
                      className={`tr_${item.id}`}
                      key={`row_item_${index + 1}`}
                      id={`row_item_${index + 1}`}
                    >
                      <td>{moment(item.datetime).format("DD/MM/YY")}</td>
                      <td title={item.sma_cross_over}>
                        {moment(item.CrossOverDate).format("DD/MM/YY")}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {diffDays(item.datetime, new Date())}
                      </td>
                      <td
                        style={{ textAlign: "left" }}
                        id={`item_${index + 1}`}
                        className={`symbolName ${item.in_watchlist ==='1'? 'inwatchlist':''}`}
                      >
                        {symbolName}

                        {item.details?.hotStar === "1" ? (
                                      <span className="hotStar"></span>
                                      ) : null}
                      </td>
                      <td>
                        <StockAction
                          symbol={symbolName}
                          delivery={false}
                          currentPrice={item.cross_price}
                          deliveryPer={item.delivery_per}
                          eventName="Golden Cross"
                          rowId={`row_item_${index + 1}`}
                          score = {item.deliveryData?.score}
                        />
                      </td>
                      <td>
                        <DeliveryGraph
                          symbol={symbolName}
                          todayLTP={item.todayLTP}
                          date={moment(NSE_Past_date[0]?.max_date).format(
                            "YYYY-MM-DD"
                          )}
                        />
                      </td>
                      <td>{item.deliveryData?.score}</td>
                      <StockStrength
                        id={`gc_${index}`}
                        selectedDate={startDate}
                        symbol={symbolName}
                        todayLTP={item.todayLTP}
                        details={item.details}
                      />
                      <td style={{ textAlign: "left" }}>
                        {item.details?.series}
                      </td>
                      <SectorPanchang
                        symbol={symbolName}
                        sector={item.details?.group_sector}
                        todayData={todayData}
                        symbolData={symbolData}
                        tag = "td"
                        align = "right"
                        durationDays = ""
                      />
                      <td style={{ textAlign: "left" }}>
                        {(() => {
                          const label = item.details?.nifty50
                            ? "50"
                            : item.details?.nifty100
                            ? "100"
                            : item.details?.nifty200
                            ? "200"
                            : item.details?.nifty500
                            ? "500"
                            : item.details?.totalMarket
                            ? "TM"
                            : "";
                          const excludedSeries = ["ETF", "BOND", "MF"];
                          const showFev =
                            item.details?.myFev &&
                            !excludedSeries.includes(item.details?.series);
                          return (
                            label + (showFev ? `${label ? ", " : ""}Fev` : "")
                          );
                        })()}
                      </td>
                      <td
                        title={`L-${item.low} | O-${item.open} | H-${item.high} | C-${item.close_price}`}
                      >
                        {item.cross_price}
                      </td>
                      <td>{item.chn_per}%</td>
                      <td>{item.todayLTP?.LTP}</td>
                      <td
                        style={{
                          color:
                            item.todayLTP?.CHANGEPER > 0 ? "#1c8b16" : "#f00",
                        }}
                      >
                        {item.todayLTP?.CHANGEPER}%
                      </td>
                      <td
                        style={{
                          color:
                            parseFloat(item.todayLTP?.LTP) -
                              parseFloat(item.cross_price) >
                            0
                              ? "#1c8b16"
                              : "#f00",
                        }}
                      >
                        {(
                          ((parseFloat(item.todayLTP?.LTP) -
                            parseFloat(item.cross_price)) *
                            100) /
                          parseFloat(item.cross_price)
                        ).toFixed(2)}
                        %
                      </td>
                      <td
                        style={{
                          background:
                            parseFloat(item.deliveryData?.SMA20) <
                            parseFloat(item.deliveryData?.SMA50)
                              ? "#fce5e5"
                              : "",
                        }}
                        title={`SMA20: ${item.deliveryData?.SMA20}`}
                      >
                        {item.deliveryData?.SMA50}
                      </td>
                      <td
                        style={{
                          background:
                            parseFloat(item.deliveryData?.SMA50) >
                            parseFloat(item.deliveryData?.SMA200)
                              ? "#e2ffe5"
                              : "#fff8f8",
                        }}
                        title={`SMA50: ${item.deliveryData?.SMA50}`}
                      >
                        {item.deliveryData?.SMA200}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {item.details?.high52w
                          ? (
                              ((item.details?.high52w - item.cross_price) *
                                100) /
                              item.details?.high52w
                            ).toFixed(2)
                          : ""}
                        %
                      </td>
                      <td
                        title={`${moment(item.details?.lowDate).format(
                          "DD-MM-YY"
                        )} / ${moment(item.details?.highDate).format(
                          "DD-MM-YY"
                        )}`}
                      >
                        {item.details?.low52w}
                        {item.details ? "/" : ""}
                        {item.details?.high52w}
                      </td>
                      <td
                          className={prevVolume > 100? "datrcolor" : ""}
                          title={`${prevVolume}%`}
                        >
                          {Number(item.deliveryData?.stock_data[0].ttl_trd_qty).toLocaleString("en-IN") }
                      </td>
                      <td 
                        className={item.deliveryData?.stock_data[0].delivery_per > item.deliveryData?.stock_data[1].delivery_per? "datrcolor" : ""}
                        title={item.deliveryData?.stock_data[1].delivery_per}>
                        {item.deliveryData?.stock_data[0].delivery_per}%
                      </td>
                      {/* <td><button type="button" className="removelist" onClick={(e) => removeStockHandler(e, item.id)}></button></td>  */}
                      <td>
                        <a
                          className="newsicon"
                          href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                          target="_blank"
                        ></a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={14}></td>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "500",
                      color: totalPL > 0 ? "#0d7607" : "#f00",
                    }}
                  >
                    {totalPL.toFixed(2)}%
                  </td>
                  <td colSpan={8}></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default GloldenCrossOverPage;
